// import { useContext } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Menu } from "./components/menu/Menu";
// import { IconButton, useTheme } from "@mui/material";
// import { useTheme } from "@mui/material";
// import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
// import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";

import {
  selectActiveTab,
  selectCurrentUser,
  selectNavigationTabs,
  selectUserCart, useCommonActions,
} from '@/entities/common';
import { UserRole } from "@/shared/types";

import NavTabs from "./components/tabs/NavTabs";
import {
  Logo,
  Wrapper,
  TabsContainer,
  LogoContainer,
  ProfileContainer,
} from "./styles";

// import {
// getMatrixByMode,
// ColorModeContext,
// } from "@/app/providers/theme/lib/logic";

export function NavBar() {
  // const theme = useTheme();
  // const colors = getMatrixByMode(theme.palette.mode);
  // const colorMode = useContext(ColorModeContext);
  const { navigationTabClicked } = useCommonActions();
  const navigate = useNavigate();

  const redirectToDefaultPage = () => {
    navigationTabClicked({ value: 0 });
    navigate(tabs[0].path);
  }

  const { cart, tabs, activeTab, currentUser } = {
    cart: useSelector(selectUserCart),
    tabs: useSelector(selectNavigationTabs),
    activeTab: useSelector(selectActiveTab),
    currentUser: useSelector(selectCurrentUser),
  };

  return (
    <Wrapper>
      <LogoContainer onClick={redirectToDefaultPage}>
        <Logo />
      </LogoContainer>
      {/* <IconButton onClick={colorMode.toggleColorMode}>
        {theme.palette.mode === "dark" ? (
          <DarkModeOutlinedIcon />
        ) : (
          <LightModeOutlinedIcon />
        )}
      </IconButton> */}
      <TabsContainer>
        <NavTabs
          cart={cart}
          tabs={tabs}
          activeTab={activeTab}
          isClientAreaNav={
            currentUser.role === UserRole.CLIENT_MANAGER ||
            currentUser.role === UserRole.CLIENT_USER
          }
          cssVariant={"navBarRegular"}
        />
      </TabsContainer>
      <ProfileContainer>
        <Menu currentUser={currentUser} />
      </ProfileContainer>
    </Wrapper>
  );
}
